import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { format, parseISO } from "date-fns";
import { ApprovalCell, ApprovalIcon } from "../../components";
import { TimeInLieu, ApprovalStatus } from "../../API";

type Actions = {
  showActionModal: (
    params?:
      | {
          row: TimeInLieu;
          status: ApprovalStatus;
        }
      | undefined
  ) => void;
};

export const columns = ({
  showActionModal,
}: Actions): GridColDef<TimeInLieu>[] => [
  {
    field: "approvalStatus",
    headerName: "Status",
    width: 72,
    align: "center",
    renderCell: ({ value }) => <ApprovalIcon status={value} />,
  },
  {
    field: "employee",
    headerName: "Employee",
    minWidth: 100,
    flex: 1,
    align: "left",
    valueGetter: ({ row: { employee } }) =>
      `${employee.firstName} ${employee.lastName}`,
  },
  {
    field: "approvedByClient",
    headerName: "Approved by Client",
    width: 100,
    align: "left",
    renderCell: ({ value }) => (
      <ApprovalIcon status={value ? "approved" : "pending"} />
    ),
  },
  {
    field: "dateTaken",
    headerName: "Date Taken",
    align: "left",
    minWidth: 112,
    renderCell: ({ value }) => format(parseISO(value), "dd/MM/yyyy"),
  },
  {
    field: "hoursTaken",
    headerName: "Hours",
  },
  {
    field: "description",
    headerName: "Description",
    align: "left",
    minWidth: 200,
  },
  {
    field: "logIds",
    headerName: "Approval",
    type: "actions",
    minWidth: 200,
    renderCell: ({ row }) => (
      <ApprovalCell
        disable={{
          approve:
            row.approvalStatus === "approved" ||
            row.approvalStatus === "rejected",
          reject: row.approvalStatus === "rejected",
        }}
        onApprove={() =>
          showActionModal({ row, status: ApprovalStatus.approved })
        }
        onReject={() =>
          showActionModal({ row, status: ApprovalStatus.rejected })
        }
      />
    ),
  },
];

export const hiddenColumnsDesktop: { [key: string]: boolean } = {};

export const hiddenColumnsMobile: { [key: string]: boolean } = {
  ...hiddenColumnsDesktop,
};
